import React, {
  createContext,
  useCallback,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';

type ShellSidebarContextValue = {
  content: React.ReactNode | null;
  setContent: (content: React.ReactNode | null) => void;
};

const ShellSidebarContext = createContext<ShellSidebarContextValue | null>(null);

export function ShellSidebarProvider({ children }: { children: React.ReactNode }) {
  const [content, setContentState] = useState<React.ReactNode | null>(null);
  const setContent = useCallback((next: React.ReactNode | null) => {
    setContentState(() => next);
  }, []);

  return (
    <ShellSidebarContext.Provider value={{ content, setContent }}>
      {children}
    </ShellSidebarContext.Provider>
  );
}

export function useShellSidebarContext() {
  const ctx = useContext(ShellSidebarContext);
  if (!ctx) {
    throw new Error('useShellSidebarContext must be used within ShellSidebarProvider');
  }
  return ctx;
}

/** Registers sidebar body content into the persistent left rail (desktop). */
export function ShellSidebarSlot({ children }: { children: React.ReactNode }) {
  const { setContent } = useShellSidebarContext();

  useLayoutEffect(() => {
    setContent(children);
    return () => setContent(null);
  }, [children, setContent]);

  return null;
}
